export const UPDATE_VISUAL_MEDIA = 'UPDATE_VISUAL_MEDIA';

export default function(state = {}, action) {
  switch (action.type) {
  case UPDATE_VISUAL_MEDIA:
    return action.payload;
  default:
    return state;
  }
}
